import React from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import WhyFiberglass from "@/components/WhyFiberglass";
import Gallery from "@/components/Gallery";
import PoolAnalysis from "@/components/PoolAnalysis";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminDashboard from "@/components/AdminDashboard";

function HomePage() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <About />
      <WhyFiberglass />
      <Gallery />
      <PoolAnalysis />
      <Testimonials />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
